import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { getUrlParams } from "../apiService/timespam";
import UpcomingSession from "../Components/UpcomingSession";
import "./Theme.css";
import "./GOQiiSessions.css";

const GOQiiSessions = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  return (
    <section className="goqii-sessions-page">
      <Tabs>
        <TabList className="sessions-tab-list">
          <Tab className="sessions-tab" selectedClassName="sessions-tab--active">{t("sessions.upcoming")}</Tab>
        </TabList>
        <TabPanel>
          <UpcomingSession />
        </TabPanel>
      </Tabs>
    </section>
  );
};

export default GOQiiSessions;
